import cloneDeep from "lodash";

const initialState = {
  call: null,
  peer: null,
  callee: null,

  remoteCallEvent: null,

  localStream: null,
  remoteStream: null,

  showWidget: false,
  connections: {},
  activeCalls: {},
}


export default {
  namespaced: true,
  state: initialState,
  getters: {
    peer: (state) => state.peer,
    call: (state) => state.call,
    callee: (state) => state.callee,
    activeCalls: (state) => state.activeCalls,

    connections: (state) => state.connections,
    getConnection: (state) => (peerId) => state.connections[peerId] || null,

    localStream: (state) => state.localStream,
    remoteStream: (state) => state.remoteStream,

    remoteCallEvent: (state) => state.remoteCallEvent,
  },
  mutations: {
    SET_CALL(state, call) {
      state.call = call
    },
    SET_CALLEE(state, callee) {
      state.callee = callee
    },
    SET_LOCAL_STREAM(state, stream) {
      state.localStream = stream
    },
    SET_REMOTE_CALL_EVENT(state, status) {
      state.remoteCallEvent = status
    },
    SET_REMOTE_STREAM(state, stream) {
      state.remoteStream = stream
    },
    SET_WIDGET_STATE(state, show) {
      state.showWidget = show
    },
    SET_OWN_PEER_CONNECTION(state, peer) {
      state.peer = peer
    },
    SET_PEER_CONNECTION(state, { peerId, connection }) {
      state.connections[peerId] = connection
    },
    UNSET_PEER_CONNECTION(state, peerId) {
      delete state.connections[peerId]
    },
    SET_REMOTE_CALL_STATE(state, { peerId, payload }) {
      state.activeCalls[peerId] = {
        ...cloneDeep(state.activeCalls[peerId]),
        ...payload
      }
    }
  },
  actions: {}
}
